
import { Component, Vue, Watch, } from 'vue-property-decorator';
import { validationMixin, } from 'vuelidate';
import { required, } from 'vuelidate/lib/validators';
import { Store, } from '~/apps/account/store';
import FeedbackBox from '~/components/feedback-box/feedback-box.vue';
import HeaderText from '~/components/header-text/header-text.vue';
import RadioGroup from '~/components/self-serve/radio-group/radio-group.vue';

@Component({
	components: {
		HeaderText,
		FeedbackBox,
		RadioGroup,
	},
	mixins: [validationMixin,],
	validations() {
		return {
			selectRating: {
				required,
			},
			feedbackInput: {
				required,
			},
			contactStatus: {
				required,
			},
		};
	},
})
export default class FeedbackSurvey extends Vue {
	selectRating:number | null = null;
	feedbackInput = '';
	contactStatus = '';
	paymentReference = Store.state.selectContractAccount;
	contactUsLocation = Store.getters.getGlobalConfigValue('ContactUsLocation');
	ratingList = [
		{
			text: 'Very Dissatisfied',
			icon: 'very-dissatisfied.svg',
		},
		{
			text: 'Dissatisfied',
			icon: 'dissatisfied.svg',
		},
		{
			text: 'Neither',
			icon: 'neither.svg',
		},
		{
			text: 'Satisfied',
			icon: 'satisfied.svg',
		},
		{
			text: 'Very Satisfied',
			icon: 'very-satisfied.svg',
		},
	];

	@Watch('feedbackInput')
	adjustHeight() {
		const textarea = this.$refs.suggestion as HTMLTextAreaElement;
		textarea.style.height = 'auto';
		textarea.style.height = `${textarea.scrollHeight}px`;
		textarea.style.overflow = 'hidden';
	}

	setFocus(param:string) {
		this.$nextTick(function() {
			const element = (this.$refs[param] as HTMLElement);
			element.focus();
			window.scrollTo({
				top: element.offsetTop,
				behavior: 'smooth',
			});
		});
	}

	async handleSubmit() {
		const currentForm = this.$v;
		currentForm.$touch();
		window.scrollTo(0, 0);
		if (currentForm.$pending || currentForm.$error) {
			return;
		}
		try {
			Store.commit.showSpinner();
			await this.$selfServeApi.feedbackLoggingFeedbackCreate({
				journey: 'General feedback',
				customerName: `${Store.state.userDetails?.firstName} ${Store.state.userDetails?.lastName}`,
				paymentReference: this.paymentReference,
				rating: this.selectRating as number,
				verbatim: this.feedbackInput,
				contactRequired: this.contactStatus,
			});
			void this.$router.push('./feedback/success');
		} catch (error) {
			void this.$router.push('./feedback/unsuccessful');
		} finally {
			Store.commit.hideSpinner();
		}
	}
}
